// extracted by mini-css-extract-plugin
export default {"menuWrapper":"dancer-menu_menuWrapper__v5+DW"};